module.exports = __webpack_public_path__ + "html/mobile-seller.template.html";